import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import FD from '../../../RestAPI/fetchData';
import language from '../../../../assets/languages/language';
import { _getProfile } from '../../../../common/function';

/* eslint-disable*/
class Soa_p_flashquestionnotes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageContent: `${language.LC().ARE_YOU_SURE_TO_DELETE_THIS}`,
      MessageTitle: `${language.LC().CONFIRMATION_BOX}`,
      items_val: '',
      item_status: '',
      flashreport: [], //All Flash question Store
      token: '',
      idname: '',
      ValidToken: false,
      no_result_display: '',
      username: '',
      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
    };
    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleClose = this.toggleClose.bind(this);
    this.toggleDone = this.toggleDone.bind(this);
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  //On Page Load ,init this method
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.location.state
      ? this.setState({ username: this.props.location.state.username })
      : null;
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    FD.callAPI(
      App_data.backend_api + '/soa_p_notes/getFlashcardsnotesbyuserid',
      data
    ).then((resp) => {
      if (resp.success) {
        this.setState({ flashreport: resp.flash_report });
        if (!resp.flash_report.length) {
          this.setState({
            no_result_display: `${language.LC().NO_SAVED_FLASHCARDS}`,
          });
        }
      } else {
        console.log(resp.success + '------------failure');
      }
    });
  }

  //Function to toggle alert box
  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  //Function to delete flash card
  toggleAlert(card) {
    this.setState({
      alert_status: !this.state.alert_status,
      item_status: card,
    });
  }

  //Function to close toggle and set items status blank
  toggleClose() {
    this.setState({
      alert_status: !this.state.alert_status,
      items_val: '',
      item_status: '',
    });
  }

  //On Click ok button from alert perform deletion of cfa flash card
  toggleDone() {
    if (this.state.item_status === 'Notesflashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };

      FD.callAPI(
        App_data.backend_api + '/soa_p_notes/deleteDashboardFlashCard',
        data
      ).then((resp) => {
        if (resp.success) {
          document
            .getElementById('notesFlash_' + this.state.items_val.id)
            .remove();
        } else {
          console.log('error');
        }
      });
    }
    this.setState({
      alert_status: false,
    });
  }

  //On click delete button ,set item value and open toggle alert
  _deleteNotesFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Notesflashcard');
  };

  //Function to redirect, page to Dashboard page
  _getDashboard = () => {
    this.context.router.push({
      pathname: '/soa/probability/dashboard/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  //Function to redirect page on specifc questions
  _beginNotes = async (reading, e) => {
    var reading_id = '';
    var chapter_id = '';
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: reading.question_id,
    };
    await FD.callAPI(
      App_data.backend_api + '/soa_p_notes/getNotesByID',
      data
    ).then((resp) => {
      if (resp.success) {
        chapter_id = resp.notes[0].chapter_id;
        reading_id = resp.notes[0].reading_id;

        this.context.router.push({
          pathname:
            '/soa/probability/beginnotes/' +
            chapter_id +
            '/' +
            reading_id +
            '/' +
            reading.question_id,
          state: {
            token: this.state.token,
            idname: this.state.idname,
            reading: reading_id,
            chapter: chapter_id,
            offset: 0,
          },
        });
      }
    });
  };

  render() {
    let flashreport_val = this.state.flashreport;
    let flashcard_data = '';
    if (this.state.flashreport.length) {
      flashcard_data = flashreport_val.map((items, index) => (
        <div id={'notesFlash_' + items.id} key={index}>
          <div className='flash_box'>
            <div className='row  align-items-center'>
              <div className='col-sm-8'>
                <span className='text_light margin_bottom_0'>
                  <strong> {language.LC().QUESTION_ID}</strong>:{' '}
                  {items.question_id}
                </span>
                <span className='margin_left_15 text_light margin_bottom_0'>
                  <strong>{language.LC().Saved_Note}: </strong>{' '}
                  {items.flash_card}
                </span>
              </div>
              <div className='col-sm-4 text-right xl-text-left'>
                <span
                  className='up tooltip-hover-questions'
                  style={{ padding: '10px' }}
                >
                  <div className='tootip_box'> {language.LC().VIEW} </div>
                  <i
                    onClick={this._beginNotes.bind(this, items)}
                    className={this.state.viewCSS}
                    style={{ color: '#1f8ceb' }}
                  >
                    {' '}
                  </i>
                </span>
                <span
                  className='up tooltip-hover-questions'
                  style={{ padding: '10px' }}
                >
                  <div className='tootip_box'> {language.LC().DELETE} </div>
                  <i
                    onClick={this._deleteNotesFlashcard.bind(this, items)}
                    className={this.state.deleteCSS}
                    style={{ color: '#f51a00' }}
                  >
                    {' '}
                  </i>
                </span>
                {/* <button className="btn_circle_sm" onClick={this._beginChapter.bind(this,items)}><i className="fa fa-eye"></i></button>
                          <button className="btn_circle_sm" onClick={this._deleteFlashcard.bind(this,items)}><i className="fa fa-trash"></i></button> */}
              </div>
            </div>
          </div>
        </div>
      ));
    } else {
      flashcard_data = (
        <div className='horizontal_mid card-block text-center text_light'>
          {language.LC().NO_FLASHCARDS}
        </div>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className='card height_70vh'>
          <div className='card-header'>
            <div className='mb-1 d-inline-block'>
              {language.LC().MY_FLASHCARDS}{' '}
              <span className='text_light margin_left_15'>
                {' '}
                {language.LC().PICK_THE_FLASHCARD_YOU_WANT_TO_REVIEW}:{' '}
              </span>
            </div>
            <div className='card-actions float-md-right'>
              <button
                type='button'
                className='btn btn-primary pointer_class'
                onClick={this._getDashboard.bind(this)}
              >
                {language.LC().DASHBOARD}
              </button>
              <button
                type='button'
                className='btn btn-primary pointer_class margin_left_15'
                onClick={_getProfile.bind(this, this.state.username)}
              >
                {language.LC().PROFILE}
              </button>
            </div>
          </div>

          {flashcard_data}
        </div>

        <Modal
          isOpen={this.state.alert_status}
          toggle={this.toggleAlert}
          className={'modal-primary ' + this.props.className}
        >
          {/*<ModalHeader toggle={this.toggleClose}>{this.state.MessageTitle}</ModalHeader>*/}
          <ModalHeader>
            {language.LC().ALERT}
            <Button className='close' onClick={this.toggleClose}>
              ×
            </Button>
          </ModalHeader>
          <ModalBody>
            <div className='text-center'>
              <p className='margin_bottom_20'>
                <strong>{this.state.MessageContent}</strong>
              </p>
              <Button className='btn btn-primary' onClick={this.toggleDone}>
                {language.LC().OK}
              </Button>
            </div>
          </ModalBody>
          {/*<ModalFooter>
                  </ModalFooter>*/}
        </Modal>
      </div>
    );
  }
}

export default Soa_p_flashquestionnotes;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/FlashQuestionNotes/FlashQuestionNotes.js